// extracted by mini-css-extract-plugin
module.exports = {"main":"custom_main__ssu3d"};